$(document).ready(function () {
	// HEADER
	if ($(window).width() <= 991) {
		$('.site-nav--is-mobile-megamenu').addClass('site-nav--is-megamenu');
		$('.mobile-menu-mega_wc').addClass('site-nav__dropdown');
		$('.mobile-menu-mega_wc').addClass('megamenu');
		$('.mobile-menu-page_wc').addClass('page-width');
		$('.mobile-menu-site_wc').addClass('site-nav-tab-wrap');
		$('.mobile-menu-site_wc ul').removeClass('site-nav__dropdown');
	};
	
	$(".icon-close.wc_close_menu").click(function () {
		$("body").removeClass("js-drawer-open");
		$("html").removeClass("js-drawer-open");
	});

  // Hide Savings element on products page if APO options are used on said page
  	if (window.location.pathname.includes('/products/')) {
		let apo = $(".mw-apo-container");

		if (apo.length > 0) {
			$(".savings-percentage").css("display", "none");
		}
	}

	$('.product-carousel-list:not(.product-recommendations-list)').each(function() {
		initSlider($(this));
	});

	$('.similar-products-carousel-list.similar-products-list').each(function() {
		initSlider($(this));
	});

  	$('.cart-fpt-carousel:not(.product-recommendations-list)').each(function() {
		$(this).slick({
			autoplay: false,
			slidesToShow: 2,
			slidesToScroll: 1,
			arrows: true,
			dots: false,
			nextArrow: '<i class="arrow right">',
			prevArrow: '<i class="arrow left">',
		});
	});

	$(document).on('recommendations:loaded', function(){
		$('.product-carousel-list.product-recommendations-list').each(function() {
			let limit = $(this).closest('.product-recommendations-placeholder').attr("data-item-limit");
			$(this).children('.recommended-item').each(function(index, el) {
				if (index >= limit) {
					el.remove();
				}
			})
			initSlider($(this));
		});
	});

	function initSlider(slider) {
		let countItem = $(slider).attr("data-item-count") || 4;
		const count = (countItem > 3) ? 4 : 3;
		$(slider).slick({
			autoplay: false,
			slidesToShow: count,
			slidesToScroll: 1,
			arrows: true,
			dots: false,
			nextArrow: '<i class="arrow right">',
			prevArrow: '<i class="arrow left">',
			responsive: [
				{
					breakpoint: 1200,
					settings: {
						slidesToShow: count,
					}
				},
				{
					breakpoint: 1008,
					settings: {
						slidesToShow: 2,
					}
				},
				{
					breakpoint: 768,
					settings: {
						slidesToShow: 1,
					}
				}
			]
		});
	}

	var item = '.product-carousel-list .slick-slide a';
	$(item).on({
		mouseenter: function () {
			if ($(this).find('.hover-image').length == 1) {
				$(this).find('.hover-image').css({ 'display': 'block' });
				$(this).find('.default-image').css({ 'display': 'none' });
			}
		},
		mouseleave: function () {
			if ($(this).find('.hover-image').length == 1) {
				$(this).find('.hover-image').css({ 'display': 'none' });
				$(this).find('.default-image').css({ 'display': 'block' });
			}
		}
	});
	
	$('button[data-modal]').click(function(e){
		let modal = $('#'+$(this).attr('data-modal'));
		modal.closest('.grid__item').css("position", "relative");
		modal.show();
		$('.wc_modal').click(function(){
			modal.hide();
			$(this).hide();
		});
	});
	
	$('.wc_close').click(function(e){
		$('.wc_modal').hide();
	})

	// Handles minimum quantity and increments defined by meta fields
	var $min = $(".product-block .qty-data").attr("data-minqty");
	var qty = $(".product__quantity  input");
	if ($min) {
		$(qty).val($min);
	}

  // Large Quote Request form
  // Populate hidden field with price of product
  if (window.location.pathname.indexOf('/products/') !== -1) {
    $("[data-modal='request_quote']").on('click', function() {
     $('.question_form iframe').contents().find('#input_18').bind("change", function() { 
      var price = $(".product__price.on-sale .money").text();
      var qty = $('.question_form iframe').contents().find('#input_18');
        if (price) {
          var price = price.replace(/\$/g, '');
          var totalPrice = price * $(qty).val();
          
          $('.question_form iframe').contents().find('#input_20').val(totalPrice.toFixed(2));
        } else {
          var price = $(".product__price.on-sale .money").text();
          var price = price.replace(/\$/g, '');
          var totalPrice = price * $(qty).val();
          
          $('.question_form iframe').contents().find('#input_20').val(totalPrice.toFixed(2));
        } 
     });
    });
  }
});


